module.exports = __webpack_public_path__ + "static/media/header_slide_06.32f94f25.jpg";